import React from 'react'
import "./Why_Choose_Us_card.css"

function Why_Choose_Us_card({ number, title, description }) {
  return (
    <>
      <section className='Why_Choose_Us_card'>
        <div className="text_holder">
          <h3>{number}</h3>
          <h5>{title}</h5>
          <div className='bdbot'></div>
          <p>{description}</p>
        </div>
      </section>
    </>
  )
}

export default Why_Choose_Us_card
